export const aptAllowedChars = 'a-zA-Z0-9-/'
export const aptRegex = /^[a-zA-Z0-9]*(?:[/-][a-zA-Z0-9]+)*$/
